import { IConfigValidation } from 'interfaces/inspection.interface'
import { ProductsType } from 'source-of-truth/productsType'
import { yupValidations } from 'utils/create-yup-schema'
import * as yup from 'yup'
export const requiredMessage = 'Campo requerido!'

export const AbstractSchemaObject = {
  email: yup.string().email().required(),
  username: yup.string().required(),
  password: yup.string().min(5).required(),
  address: yup
    .string()
    .required('required field')
    .matches(/^[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9\s,.'-]{3,}$/, 'invalid format'),
  country: yupValidations.consumer.country,
  state: yupValidations.consumer.state,
  city: yup.string(),
  date: yup
    .date()
    .typeError('invalid value')
    .transform((value, originalValue) => {
      try {
        const dayMonthYear = originalValue
          .split('/')
          .map((time: string) => parseInt(time))

        return new Date(
          `${dayMonthYear[2]}/${dayMonthYear[1]}/${dayMonthYear[0]}`
        )
      } catch (err) {
        return null
      }
    }),
  postalCode: yup.string(),
  phone: yup.string(),
  stringNumber: yup.string().matches(/^\d+$/).required(),
  sex: yupValidations.consumer.state,
  productType: yup.string().oneOf(Object.values(ProductsType)).required(),
  configValidation: yup
    .object()
    .shape<Record<keyof IConfigValidation, yup.AnySchema>>({
      approved: yup.boolean(),
      required: yup.boolean(),
    }),
}
